export type ErrorOptions = {
  /**
   * Expect cause to be an Error instance
   */
  cause: Error;
};

/**
 * HttpError provides a single error class to handle all failure responses
 * from the fetch request.
 */
export class HttpError extends Error {
  public status: number | undefined;

  constructor(response?: Response, options?: ErrorOptions) {
    let errorMsg = "an unknown error";

    if (options?.cause.name === "SyntaxError") {
      errorMsg = "an invalid json response";
    } else {
      errorMsg = response?.statusText ?? errorMsg;
    }

    super(`Request failed with ${errorMsg}`);

    this.name = "HttpError";
    this.status = response?.status;
  }
}

export default HttpError;
